$(document).ready(function () {
  "use strict";

  $(".order--container").on("click", function () {
    if ($(this).hasClass("follow__link") == false) {
      var orderId = $(this).attr("order-id");
      $('.order__details[order-id="' + orderId + '"]')
        .slideToggle(200)
        .toggleClass("is-active");
      $(this).toggleClass("child-active");
      $(this)
        .children(".open__line__items--link")
        .children()
        .toggleClass("rotate-180");
    }
  });
  ("use strict");

  if (window.collection) {
    var selectedInput = $(
      '.select__custom--value[value="' + window.collection.defaultSortBy + '"]'
    )
      .first()
      .text();

    $(
      '.select__custom--value[value="' + window.collection.defaultSortBy + '"]'
    ).addClass("bg-primary/20 is-active");
    $(".select__custom--selected-value").text(selectedInput);
  }

  $(".see-all-tag-collection").on("click", function () {
    $(".tag-clic-collection--container")
      .addClass("opened md:justify-center")
      .removeClass("md:justify-start");
    $(this).hide();
  });

  var updateProductPromotion = function (filter) {
    const filterValues = filter
      .filter((f) => f.type === "filter.v.m.bloon.promotion")
      .map((f) => f.value);
    if (filterValues.length > 0) {
      document
        .querySelectorAll(".product__item--container")
        .forEach((productGrid) => {
          if (
            !filterValues.includes(productGrid.getAttribute("data-promotion"))
          ) {
            productGrid.style.display = "none";
          }
        });
    }
  };

  if (
    window.location.href.indexOf("collections/") > -1 &&
    window.general.collection
  ) {
    var printUrl = function printUrl(list) {
      var filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "?";
      for (var filter in list) {
        filteredUrl += list[filter].type + "=" + list[filter].value + "&";
      }

      var sortBy = $(
        "#sort__by--container .select__custom--value.is-active"
      ).attr("value");
      var filterSortBy = "sort_by=" + sortBy;

      var pageUrl = "";
      var finalUrl = filteredUrl + filterSortBy + pageUrl;

      if (history.replaceState) {
        window.history.replaceState({ path: finalUrl }, "", finalUrl);
      }

      $.ajax({
        type: "GET",
        url: finalUrl + "&view=filtered",
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $("#collection__list--container").remove();
          $("#collection__page--desktop").append(content.substring(4));

          clearFilter();
          dataFilter = boucleFilter();
          updateProductPromotion(dataFilter);
          console.log(dataFilter);
        },
        error: function error(_error2) {
          console.log("erreur");
        },
      });
    };

    // Filters
    $("body").on("click", ".reinitialize__filters", function () {
      window.collection.currentFilters = [];
      $(".reinitialize__filters").hide();
      $(".filter__button").removeClass("is__active");
      $(".filter--container, .checkbox-filter--container").removeClass(
        "checked"
      );
      var filteredUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.collection.collectionUrl +
        "?sort_by=" +
        window.collection.sortBy;
      if (history.replaceState) {
        window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
      }
      $.ajax({
        type: "GET",
        url: filteredUrl + "&view=filtered",
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $("#collection__list--container").remove();
          $("#collection__page--desktop").append(content.substring(4));
        },
        error: function error(_error) {
          console.log("erreur");
        },
      });
    });

    var collectionFilter = {};
    if ($("[collection-filter]").html()) {
      collectionFilter = JSON.parse($("[collection-filter]").html());
    }

    var clearFilter = function clearFilter() {
      var url = window.location.href;
      var matches = url.match(/[a-z\d]+=[a-z\d]+/gi);
      var count = matches ? matches.length : 0;
      if (window.location.search.indexOf("page=") > -1) {
        count = count - 1;
      }
    };

    $(document).ready(function () {
      clearFilter();
    });

    var dataFilter = [];

    var boucleFilter = function boucleFilter() {
      var array = [];
      $(".filter-group-display__list").each(function () {
        var containerFilter = $(this).children(
          ".filter-group-display__list-item"
        );

        var checkbox = containerFilter
          .children(".filter--container")
          .children(".checkbox-filter--container");
        var value = "";
        var name = checkbox.attr("name");
        var compteurCheck = 0;
        for (var i = 1; i <= containerFilter.length; i++) {
          var loopCheckbox = containerFilter
            .children(".filter--container")
            .children(".checkbox-" + i);

          if (loopCheckbox.hasClass("checked")) {
            if (name == "filter.v.option.taille") {
              array.push({ type: "filter.v.availability", value: 1 });
            }

            compteurCheck += 1;

            compteurCheck == 1
              ? (value = loopCheckbox.attr("value"))
              : (value = value + "," + loopCheckbox.attr("value"));
          }
        }
        compteurCheck > 0 ? array.push({ type: name, value: value }) : null;
      });

      var nameFilterLow = $("#lowPriceFilter").attr("name");
      var valueLow = $("#lowPriceFilter").val();

      var nameFilterHigh = $("#highPriceFilter").attr("name");
      var valueHigh = $("#highPriceFilter").val();
      var maxValueHigh = $("#highPriceFilter").attr("max");

      if (parseInt(valueLow) > 0) {
        array.push({ type: nameFilterLow, value: valueLow });
      }

      if (parseInt(valueHigh) <= parseInt(maxValueHigh)) {
        console.log("passe max value");
        array.push({ type: nameFilterHigh, value: valueHigh });
      }

      return array;
    };

    if (window.location.href.indexOf("collections") > -1) {
      dataFilter = boucleFilter();

      console.log("Chargement");
      console.log(dataFilter);
      updateProductPromotion(dataFilter);
      console.log("Chargement");
    }

    $("body").on("click", ".filter--container", function () {
      var filterTaille = $(this)
        .find(".checkbox-filter--container")
        .attr("name");
      if ($(this).find(".checkbox-filter--container").hasClass("checked")) {
        var filterName = $(this)
          .find(".checkbox-filter--container")
          .attr("filtername");
        $(
          ".active-filters__remove-filter[filtername=" + filterName + "]"
        ).remove();
      } else {
        var filterName = $(this)
          .find(".checkbox-filter--container")
          .attr("filtername");

        if (filterName == "Disponibilité-Enstock") {
          var filterValue = "En stock";
        } else if (filterTaille == "filter.v.option.taille") {
          console.log("Taille click");
          $(".taille--container").removeClass("checked");
          $(".taille--container")
            .children(".checkbox-filter--container")
            .removeClass("checked");
        } else {
          var filterValue = $(this)
            .find(".checkbox-filter--container")
            .attr("value");
        }
        $(".active-filters").append(
          '\n        <a class="active-filters__remove-filter cursor--pointer" filtername="' +
            filterName +
            '">\n            ' +
            filterValue +
            " X\n        </a>\n      "
        );
      }

      var checkboxContainer = $(this).children(".checkbox-filter--container");
      checkboxContainer.hasClass("checked")
        ? checkboxContainer.removeClass("checked")
        : checkboxContainer.addClass("checked");
      $(this).hasClass("checked")
        ? $(this).removeClass("checked")
        : $(this).addClass("checked");
      dataFilter = boucleFilter();
      printUrl(dataFilter);
    });

    var countEuro = 1;
    $("body").on("click", ".filter-group-summary", function () {
      if ($(this).hasClass("checked")) {
        $(this).removeClass("checked");
        $(this).siblings(".filter-group-display").slideToggle(200);
        $(this).children(".plus__icon").removeClass("opened");
      } else {
        $(this).addClass("checked");
        $(this).siblings(".filter-group-display").slideToggle(200);
        $(this).children(".plus__icon").addClass("opened");

        setTimeout(function () {
          if (countEuro == 1) {
            countEuro = countEuro + 1;
            $(".irs-from, .irs-to").append(" €");
          }
        }, 200);
      }
    });

    $("body").on("click", ".see-more", function () {
      var which = $(this).attr("which");
      $('.see-more[which="' + which + '"]').hide();
      $('.see-less[which="' + which + '"]').show();

      $(".filter-group-display." + which + "--container").addClass("opened");
    });

    $("body").on("click", ".see-less", function () {
      var which = $(this).attr("which");
      $('.see-more[which="' + which + '"]').show();
      $('.see-less[which="' + which + '"]').hide();

      $(".filter-group-display." + which + "--container").removeClass("opened");
    });

    $("body").on("click", ".active-filters__clear", function () {
      var link = $(this).attr("link");
      $(".filter--container, .checkbox-filter--container").removeClass(
        "checked"
      );
      $("#lowPriceFilter").attr("value", 0);
      var maxRangeValue = collectionFilter.filterMaxRange / 100;

      $("#highPriceFilter").attr("value", maxRangeValue);
      $("#highPriceFilter").val(maxRangeValue);
      to = maxRangeValue;
      from = 0;
      updateValues();
      updateRange();
      $(".irs-from, .irs-to").append(" €");
      window.history.replaceState({ path: link }, "", link);

      countFilterActive = 0;
      $(".count-filter--container").addClass("hide");

      $.ajax({
        type: "GET",
        url: link + "&view=filtered",
        success: function success(content) {
          var count = parseInt(content.substring(0, 4));
          $(".filter-count").text(count);
          $(
            "#collection__list--container, .collection-remove--container"
          ).remove();
          $("#collection__page--desktop").append(content.substring(4));

          clearFilter();
        },
        error: function error(_error3) {
          console.log("erreur");
        },
      });
    });
  }
  ("use strict");

  // Ouvrir la modal au clic
  $("body").on("click", ".button__action", function (e) {
    e.preventDefault();
    var buttonFor = $(this).attr("for");
    var selector = $(this).attr("open-selector");

    if (selector) {
      $(selector).addClass("opened");
    }
    if (selector == "#filter-collection-drawer") {
      $("#page__overlay--navigation").addClass("opened");
    } else {
      $("#page__overlay").addClass("opened");
    }

    if (buttonFor == "drawer" && selector) {
      $("#page__overlay--navigation").attr("for", "drawer");
    } else if (buttonFor == "accordeon") {
      var isActive = false;
      if ($(this).hasClass("active")) {
        isActive = true;
      }
      if ($(this).hasClass("link--item-button")) {
        $(".link--item-button.active")
          .siblings(".accordeon__list")
          .removeClass("opened")
          .slideToggle("500");
        $(".link--item-button.active")
          .children(".plus__icon")
          .removeClass("opened");
        $(".link--item-button.active").removeClass("active");
      } else if ($(this).hasClass("sub__link--item-button")) {
        $(".sub__link--item-button.active")
          .siblings(".accordeon__list")
          .removeClass("opened")
          .slideToggle("500");
        $(".sub__link--item-button.active")
          .children(".plus__icon")
          .removeClass("opened");
        $(".sub__link--item-button.active").removeClass("active");
      }

      if (isActive == false) {
        $(this).toggleClass("active");
        $(this).children(".plus__icon").toggleClass("opened");
        $(this)
          .siblings(".accordeon__list")
          .addClass("opened")
          .slideToggle("500");
      }
    } else if (buttonFor == "modal" && selector) {
      $("#page__overlay").attr("for", "modal");
    }
  });

  // Fermer la modal au clic sur la croix
  $("body").on("click", ".close", function (e) {
    e.preventDefault();
    var closeFor = $(this).attr("for");

    if (closeFor == "drawer-reco") {
    } else {
      $("#page__overlay, #page__overlay--navigation").removeClass("opened");
      $("#page__overlay, #page__overlay--navigation").attr("for", "");
    }

    if (closeFor == "drawer") {
      $(".drawer").removeClass("opened");
    } else if (closeFor == "modal") {
      $(".modal").removeClass("opened");
      $(".modal-loader").show();
      $(".modal-has-to-load").hide();
    }
  });

  // Clic en dehors de la'modal'
  $("#page__overlay, #page__overlay--navigation").on("click", function (e) {
    e.preventDefault();
    var overlayFor = $(this).attr("for");

    $(this).removeClass("opened");
    $("#page__overlay, #page__overlay--navigation").attr("for", "");

    if ($(".search--container").hasClass("opened")) {
      $(".search--container").removeClass("opened").css("transform", "");
      $(".searchProduct").val("");
      $(".result-search").html("");
    }

    if (overlayFor == "drawer") {
      $(".drawer").removeClass("opened");
    } else if (overlayFor == "modal") {
      $(".modal").removeClass("opened");
      $(".modal-loader").show();
      $(".modal-has-to-load").hide();
    }
  });
  ("use strict");

  $("body").on(
    "click",
    ".select__custom--selected-value-container",
    function (e) {
      var forSelect = $(this).attr("for");

      $('.select__custom--values[for="' + forSelect + '"]')
        .fadeToggle(50)
        .addClass("opened");
      $('.select__custom--values:not([for="' + forSelect + '"])')
        .hide()
        .removeClass("opened");
      $(this).toggleClass("rounded-b-none border-b-0");
      $(this).children(".icon--arrow-bottom").toggleClass("opened");
      $(
        '.select__custom--selected-value-container:not([for="' +
          forSelect +
          '"])'
      )
        .children(".icon--arrow-bottom")
        .removeClass("opened");
    }
  );

  $("body").on("click", ".select__custom--value", function (e) {
    var forSelect = $(this).attr("for");
    var value = $(this).attr("value");
    var color = $(this).attr("color");
    var valueText = $(this).text();

    $('.select__custom--value[for="' + forSelect + '"]').removeClass(
      "bg-primary/20"
    );
    $(this).addClass("bg-primary/20");
    if (forSelect == "sort--by") {
      $('.select__custom--value[for="' + forSelect + '"]').removeClass(
        "is-active"
      );
      $(this).addClass("is-active");
    }
    $(".select__custom--selected-value-container").removeClass(
      "rounded-b-none border-b-0"
    );
    $(".select__custom--selected-value-container")
      .children(".icon--arrow-bottom")
      .removeClass("opened");
    if ($(this).hasClass("color-click")) {
      $(".color-text-replace, .color-banner").text(color);
    } else {
      $('.select-text-replace[name="' + forSelect + '"]')
        .text(value)
        .removeClass("text-[#9b9b9b]")
        .addClass("text-grey");
    }

    $('.select__custom--selected-value-banner[name="' + forSelect + '"]').text(
      value
    );

    if (forSelect == "sort--by") {
      $('.select__hidden[for="' + forSelect + '"]')
        .val(value)
        .trigger("change");
      $(".select__custom--selected-value").text(valueText);
    } else {
      $('.select__hidden[for="' + forSelect + '"]').text(value);
    }

    $(".select__custom--values").hide().removeClass("opened");

    document.dispatchEvent(new CustomEvent("select-changed:product__option"));
  });

  $(document).on("click", function (e) {
    var product = $(".select__custom--values");
    var product2 = $(".click-select");
    if (product.is(e.target) || product2.is(e.target)) {
    } else {
      if (product.hasClass("opened")) {
        $(product).hide().removeClass("opened");
        $(".select__custom--selected-value-container")
          .children(".icon--arrow-bottom")
          .removeClass("opened");
        $(".select__custom--selected-value-container").removeClass(
          "rounded-b-none border-b-0"
        );
      }
    }
  });

  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
          decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  $('.select__hidden[for="sort--by"]').bind("change", function () {
    console.log("passe sort by");
    Shopify.queryParams.sort_by = $(this).val();
    var filteredUrl = window.location.href;

    var url = new window.URL(window.location.href);
    url.searchParams.set("sort_by", Shopify.queryParams.sort_by);
    console.log(url.toString());

    filteredUrl = url.toString().replace("%2C", ",");

    if (history.replaceState) {
      window.history.replaceState({ path: filteredUrl }, "", filteredUrl);
    }

    $.ajax({
      type: "GET",
      url: filteredUrl + "&view=filtered",
      success: function success(content) {
        var count = parseInt(content.substring(0, 4));
        $(".filter-count").text(count);
        $("#collection__list--container").remove();
        $("#collection__page--desktop").append(content.substring(4));

        //clearFilter()
      },
      error: function error(_error) {
        console.log("erreur");
      },
    });
  });

  $(".color-product").on("click", function () {
    var color = $(this).find(".select__custom--value").attr("color");
    var forName = $(this).attr("for");
    var colorDown = $(this)
      .find(".select__custom--value")
      .attr("color")
      .toLowerCase();
    console.log(colorDown);

    $(".select__custom--selected-value[name=" + forName + "]").text(color);
    $(".color-product").removeClass(
      "after:absolute after:border-primary-light after:border-[2px] after:top-0 after:left-0 after:w-full after:h-full"
    );
    $(this).addClass(
      "after:absolute after:border-primary-light after:border-[2px] after:top-0 after:left-0 after:w-full after:h-full"
    );
  });
  ("use strict");

  var prevArrow =
    '<svg class="slick-arrow--left absolute top-[50%] translate-y-[-50%] w-[50px] h-[50px] bg-white rounded-full p-[10px] left-[50px] 3xl:left-[40px] 2xl:left-[20px] lg:left-[15px] z-[2] cursor-pointer md:h-[36px] md:w-[36px] md:p-[5px]" viewBox="0 0 53.4 18.8"><path style="fill:#DD6640;" d="M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z"/></svg>';
  var nextArrow =
    '<svg class="slick-arrow--right absolute top-[50%] translate-y-[-50%] w-[50px] h-[50px] bg-white rounded-full p-[10px] right-[50px] 3xl:right-[40px] 2xl:right-[20px] lg:right-[15px] z-[2] cursor-pointer md:h-[36px] md:w-[36px] md:p-[5px]" x="0px" y="0px"viewBox="0 0 53.4 18.8" style="enable-background:new 0 0 53.4 18.8;" xml:space="preserve"><path style="fill:#DD6640;" d="M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z"/> </svg>';

  var initSlick = function initSlick() {
    $(".background-slider").slick({
      dots: false,
      infinite: false,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $(".slider-completez").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
    });

    $(".announcement-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      dots: false,
      infinite: true,
      arrows: false,
    });

    $(".slider-logo").slick({
      dots: false,
      infinite: false,
      arrows: false,
      slidesToShow: 7,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });

    $(".slider-infos-cart").slick({
      dots: true,
      customPaging: function customPaging(slider, i) {
        return '<button class="tab"></button>';
      },
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $("#bandeau--footer-slider").slick({
      dots: false,
      infinite: true,
      arrows: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 3,
            autoplay: true,
            autoplaySpeed: 3000,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true,
            customPaging: function customPaging(slider, i) {
              return '<button class="tab"></button>';
            },
          },
        },
      ],
    });
    if (window.matchMedia("(min-width: 768px)").matches) {
      $(".four-product-slider").slick({
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        slidesToShow: 5,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        responsive: [
          {
            breakpoint: 950,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    $(".slider-video").slick({
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });

    $(".slider-collection").slick({
      dots: false,
      infinite: true,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
    $(".slider-title-infos").slick({
      dots: false,
      infinite: true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: ".slider-infos-infos",
    });
    $(".slider-infos-infos").slick({
      dots: false,
      infinite: false,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            arrows: false,
          },
        },
      ],
    });

    if (window.matchMedia("(max-width: 767px)").matches) {
      $(".slider-review-mobile").slick({
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
      });
      $(".slider-gonfler").slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        variableWidth: true,
      });
    }

    if (window.matchMedia("(max-width: 1200px)").matches) {
      $(".slider-rea-header").slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 950,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    $(".slider-list-collections, .slider-avis-one-client").slick({
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      variableWidth: true,
    });

    $(".slider-avis").slick({
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      centerMode: true,
      variableWidth: true,
    });
  };

  initSlick();

  document.addEventListener(
    "theme-editor--slick",
    function (e) {
      $(".background-slider").filter(".slick-initialized").slick("unslick");
      $(".carousel-product-list").filter(".slick-initialized").slick("unslick");
      $(".blog-slider").filter(".slick-initialized").slick("unslick");
      $("#instagram-feed").filter(".slick-initialized").slick("unslick");
      $("#bandeau--footer-slider")
        .filter(".slick-initialized")
        .slick("unslick");

      initSlick();
    },
    false
  );

  if (window.matchMedia("(max-width: 767px)").matches) {
    $(window).on("load", function () {
      $(".slider-rea-header .text-slide").css("opacity", "1");
    });
  }

  ("use strict");

  $("body").on("click", ".atc", function () {
    console.log("click atc");
    var attribute = $(this).attr("data-atc");
    if (event.ctrlKey || $(this).hasClass("atc_blank")) {
      var newWindow = window.open(
        decodeURIComponent(window.atob(attribute)),
        "_blank"
      );
      newWindow.focus();
    } else {
      document.location.href = decodeURIComponent(window.atob(attribute));
    }
  });
  ("use strict");
  ("use strict");

  $(".button__with__loading").on("click", function () {
    $(this).children(".text--loading").hide();
    $(this).children(".button--loading").css("display", "flex");
  });

  function deferSrcImages(className) {
    var imgDefer = document.getElementsByClassName(className);
    for (var i = 0; i < imgDefer.length; i++) {
      if (imgDefer[i].getAttribute("defer-src")) {
        imgDefer[i].setAttribute("src", imgDefer[i].getAttribute("defer-src"));
      }
    }
  }

  window.onload = function () {
    setTimeout(function () {
      deferSrcImages("defer--product");
    }, 200);
  };

  $(".title-collection").on("click", function () {
    var option = $(this).attr("collection");

    if ($(this).hasClass("line-under")) {
    } else {
      $(".title-collection").removeClass("line-under").addClass("opacity-30");
      $(this).removeClass("opacity-30").addClass("line-under");
    }
    $(".slider-triple-collection").hide();
    $('.slider-triple-collection[collection="' + option + '"]').css(
      "display",
      "block"
    );
  });

  $(".title-infos").on("click", function () {
    var index = $(this).attr("thumb-index");
    $(".slider-infos-infos").slick("slickGoTo", index);
    $(".title-infos").removeClass("line-under-light").addClass("opacity-30");
    $(this).addClass("line-under-light").removeClass("opacity-30");
  });

  $(".slider-infos-infos").on(
    "afterChange",
    function (event, slick, direction) {
      var currentSlide = $(".slider-infos-infos").slick("slickCurrentSlide");
      $(".title-infos").removeClass("line-under-light").addClass("opacity-30");
      $(".title-infos[thumb-index=" + currentSlide + "]")
        .addClass("line-under-light")
        .removeClass("opacity-30");
    }
  );

  $(".choice-langage").on("click", function () {
    if ($(".container-choice-langage").hasClass("hidden")) {
      $(".container-choice-langage").removeClass("hidden");
    } else {
      $(".container-choice-langage").addClass("hidden");
    }
  });

  $(".ancre-link").on("click", function () {
    var link = $(this).attr("link");
    $("html, body").animate(
      {
        scrollTop: $("." + link).offset().top - 200,
      },
      500
    );
  });
  ("use strict");

  $("#go-top").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500
    );
  });

  if ($(document).scrollTop() > 20) {
    $("#go-top").show();
  } else {
    $("#go-top").hide();
  }

  $(document).on("scroll", function () {
    if ($(document).scrollTop() > 20) {
      $("#go-top").show();
    } else {
      $("#go-top").hide();
    }
  });
  ("use strict");

  var displayPrice = function displayPrice(price) {
    if (window.general.currency == "£" || window.general.currency == "$") {
      return window.general.currency + price / 100;
    } else {
      return price / 100 + "€";
    }
  };
  ("use strict");

  var pageOverlayOpened = false;
  $(".navigation__item--link-megamenu").mouseenter(function () {
    if (pageOverlayOpened == false) {
      $("#page__overlay--navigation").addClass("opened");
      pageOverlayOpened = true;
    }
  });

  $(".navigation__item--link-megamenu").mouseleave(function () {
    if (pageOverlayOpened == true) {
      $("#page__overlay--navigation").removeClass("opened");
      pageOverlayOpened = false;
    }
  });

  // Gestion de la hauteur du drawer sur mobile
  // a utiliser si le drawer ne fait pas 100% de l'ecran, sinon on peut commenter
  if ($(document).scrollTop() > 20) {
    var navbarHeightMobile = 40;
  } else {
    var navbarHeightMobile = 74;
  }
  $("#navigation__drawer").css("height", window.innerHeight); // init
  $(document).on("scroll", function () {
    if ($(document).scrollTop() > 20) {
      var navbarHeightMobile = 40;
    } else {
      var navbarHeightMobile = 74;
    }
    $("#navigation__drawer").css("height", window.innerHeight);
  });

  $(".assises-hover").mouseenter(function () {
    var assises = $(this).attr("assises");
    $(".assises-hover--container").addClass("hidden");
    $(".assises-hover--container[assises='" + assises + "']").removeClass(
      "hidden"
    );
  });

  var heightFilterDrawer;
  if (window.matchMedia("(max-width: 767px)").matches) {
    if ($(document).scrollTop() > 20) {
      heightFilterDrawer = 100;
    } else {
      heightFilterDrawer = 138;
    }
  } else if (window.matchMedia("(max-width: 1100px)").matches) {
    if ($(document).scrollTop() > 20) {
      heightFilterDrawer = 105;
    } else {
      heightFilterDrawer = 141;
    }
  } else {
    if ($(document).scrollTop() > 20) {
      heightFilterDrawer = 133;
    } else {
      heightFilterDrawer = 169;
    }
  }

  $("#filter-collection-drawer")
    .css("height", window.innerHeight - heightFilterDrawer)
    .css("top", heightFilterDrawer); //init
  $(document).on("scroll", function () {
    if (window.matchMedia("(max-width: 767px)").matches) {
      if ($(document).scrollTop() > 20) {
        heightFilterDrawer = 100;
      } else {
        heightFilterDrawer = 138;
      }
    } else if (window.matchMedia("(max-width: 1100px)").matches) {
      if ($(document).scrollTop() > 20) {
        heightFilterDrawer = 105;
      } else {
        heightFilterDrawer = 141;
      }
    } else {
      if ($(document).scrollTop() > 20) {
        heightFilterDrawer = 133;
      } else {
        heightFilterDrawer = 169;
      }
    }
    $("#filter-collection-drawer")
      .css("height", window.innerHeight - heightFilterDrawer)
      .css("top", heightFilterDrawer);
  });
  ("use strict");

  if (
    window.location.href.indexOf("blog") > -1 ||
    window.location.href.indexOf("article") > -1
  ) {
    $("#icon-search-blog, #icon-search-blog-2").on("click", function () {
      if ($(".search--container").hasClass("opened-blog")) {
        $(".search--container").removeClass("opened-blog");
        $(".searchArticle").val("");
        $(".result-search").html("");
      } else {
        $(".search--container").addClass("opened-blog");
      }
    });

    var handleCloseSearch = function handleCloseSearch() {
      $(".searchArticle").val("");
      $(".result-search").html("");
      $(".search--container").removeClass("opened-blog");
      $(".search--container").css("transform", "");
    };

    $(".close--search").on("click", function () {
      handleCloseSearch();
    });

    $(document).on("click", function (e) {
      var container = $(".search--container");
      var container2 = $(".search--container-barre");
      if ($(e.target).hasClass("search--trigger")) {
      } else {
        if (
          container.hasClass("opened-blog") &&
          !container.is(e.target) &&
          container.has(e.target).length === 0
        ) {
          handleCloseSearch();
        }
      }

      if (!container2.is(e.target) && container2.has(e.target).length === 0) {
        $(".searchArticle-barre").val("");
        $(".result-search-barre").html("");
      }
    });
  } else {
    var handleSearchBar = function handleSearchBar(
      searchTriggerId,
      positionScrolledClass,
      positionClass,
      translateYScrolled,
      translateY
    ) {
      $(searchTriggerId).on("click", function () {
        console.log("passe");
        if (
          $(".search--container").hasClass(positionScrolledClass) ||
          $(".search--container").hasClass(positionClass)
        ) {
          $("#page__overlay--navigation").removeClass("opened");
          $(".navigation__item--container").removeClass("search--opened");
          $("#navigation--container").removeClass("fixedWhiteNav");
          $(".search--container")
            .removeClass(positionScrolledClass + " " + positionClass)
            .css("transform", "");
          $(".searchProduct").val("");
          $(".result-search").html("");
          $(".popular_product").removeClass("opened");
        } else {
          $("#page__overlay--navigation").addClass("opened");
          $("#navigation--container")
            .addClass("fixedWhiteNav")
            .removeClass("transparent--nav");
          $(".popular_product").addClass("opened");
          if ($(document).scrollTop() >= 20) {
            $(".search--container").addClass(positionScrolledClass);
            $(
              ".search--container." +
                positionClass +
                ", .search--container." +
                positionScrolledClass
            ).css("transform", "translateY(" + translateYScrolled + "px)");
          } else {
            var topPosition = translateY - $(document).scrollTop();
            $(".search--container").addClass(positionClass);
            $(
              ".search--container." +
                positionClass +
                ", .search--container." +
                positionScrolledClass
            ).css("transform", "translateY(" + topPosition + "px)");
          }
        }
        $(".searchProduct.search--input").focus();
      });

      $(document).on("scroll", function () {
        if ($(document).scrollTop() >= 20) {
          $(
            ".search--container." +
              positionClass +
              ", .search--container." +
              positionScrolledClass
          ).css("transform", "translateY(" + translateYScrolled + "px)");
        } else {
          var topPosition = translateY - $(document).scrollTop();
          $(
            ".search--container." +
              positionClass +
              ", .search--container." +
              positionScrolledClass
          ).css("transform", "translateY(" + topPosition + "px)");
        }
      });
    };

    if (window.matchMedia("(max-width: 767px)").matches) {
      handleSearchBar("#icon-search-2", "opened", "opened", 300, 338);
    } else if (window.matchMedia("(max-width: 1100px)").matches) {
      handleSearchBar("#icon-search-2", "opened", "opened", 305, 341);
    } else {
      handleSearchBar("#icon-search", "opened", "opened", 333, 369);
    }

    var handleCloseSearch = function handleCloseSearch() {
      $(".searchProduct").val("");
      $(".result-search").html("");
      $(".search--container")
        .removeClass(
          "opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2"
        )
        .css("transform", "");
      $("#navigation--container").removeClass("fixedWhiteNav");
      $("#page__overlay--navigation").removeClass("opened");
      $(".navigation__item--container").removeClass("search--opened");
      $(".popular_product").removeClass("opened");
    };

    $(".close--search").on("click", function () {
      handleCloseSearch();
    });

    $(document).on("click", function (e) {
      var container = $(".search--container");
      if ($(e.target).hasClass("search--trigger")) {
      } else {
        if (
          (container.hasClass("opened") ||
            container.hasClass("opened-mobile") ||
            container.hasClass("opened-mobile2")) &&
          !container.is(e.target) &&
          container.has(e.target).length === 0
        ) {
          handleCloseSearch();
        }
      }
    });

    $(document).on("click", ".global-search", function () {
      //var url = window.location.hostname
      var search = document.getElementsByClassName("searchProduct")[0].value;
      var redirection = "/search?type=product&q=" + search;
      window.location.replace(redirection);
      $(".search--container").removeClass("opened");
    });
  }

  $(document).on("input", ".search--input", function () {
    if ($(this).attr("search") === "barre") {
      SearchFunction("searchArticle-barre", "article", "result-search-barre");
    } else if ($(this).attr("search") === "article") {
      SearchFunction("searchArticle", "article", "result-search");
    } else if ($(this).attr("search") === "produit") {
      SearchFunction("searchProduct", "product", "result-search");
    }
  });

  var SearchFunction = function SearchFunction(
    classInput,
    typeSearch,
    classInputResult
  ) {
    var htmlItem = function htmlItem(type, item, index) {
      if (type == "article") {
        return (
          "<div class='one-product'><a class='flex fd--row jc--flex-start' href=" +
          item[index].url +
          "><img class='image-product' src=" +
          item[index].image +
          "><div class='content--container flex fd--column ai--flex-start'><p class='price--grid dark__color'>" +
          item[index].title +
          "</p></div></a></div>"
        );
      } else {
        if (item[index].compare_at_price_max == 0.0) {
          if (
            window.general.currency == "£" ||
            window.general.currency == "$"
          ) {
            var prix =
              window.general.currency + item[index].price.replace(".", ",");
          } else {
            var prix = item[index].price.replace(".", ",") + "€";
          }
        } else {
          if (
            window.general.currency == "£" ||
            window.general.currency == "$"
          ) {
            var prix =
              window.general.currency +
              item[index].price.replace(".", ",") +
              "<span class='line-through mx-[10px] mr-0 body--text-small text-grey/50 line-through'>" +
              window.general.currency +
              item[index].compare_at_price_max.replace(".", ",") +
              "</span>";
          } else {
            var prix =
              item[index].price.replace(".", ",") +
              "€<span class='line-through mx-[10px] mr-0 body--text-small text-grey/50 line-through'>" +
              item[index].compare_at_price_max.replace(".", ",") +
              "€</span>";
          }
        }
        return (
          " <div class='one-product px-[15px] py-[10px]'><a class='flex flex-row items-center ' href=" +
          item[index].url +
          "><img class='w-[70px] h-auto object-contain' src=" +
          item[index].image +
          "><div class='flex flex-col mx-[15px] mr-0'><p class='product--title font-semibold text-[17px] text-grey'>" +
          item[index].title +
          "</p><p class='price body--text-small text-grey'>" +
          prix +
          "</p></div></a></div>"
        );
      }
    };

    var emptyItem = function emptyItem(type) {
      if (type == "article") {
        return `<div class='empty'>${window.general.no_article_matches_search_translate}</div>`;
      } else {
        return `<div class='empty px-[20px] py-[10px] text-center col-start-1 col-end-5 2xl:col-end-3'>${window.general.no_product_matches_search_translate}</div>`;
      }
    };

    var q = document.getElementsByClassName(classInput)[0].value;
    var b = "&resources[type]=" + typeSearch;
    var c = "";
    if (q == "") {
      $(".result-search").html("");
      $(".result-search-barre").html("");
    }
    if (typeSearch == "article") {
      var type = "article";
    } else {
      var type = "product";
      c = "&fields=title,product_type,tag";
      if (q == "") {
        $(".popular_product").addClass("opened");
      } else {
        $(".popular_product").removeClass("opened");
      }
    }
    if (window.location.pathname.match(/^\/en-uk/)) {
      var first = `/en-uk/search/suggest.json?q=`;
    } else if (window.location.pathname.match(/^\/en/)) {
      var first = `/en/search/suggest.json?q=`;
    } else {
      var first = "/search/suggest.json?q=";
    }

    $.ajax(first + q + b + c, {
      type: "GET",
      dataType: "json",
      success: function success(response) {
        var itemsSuggestions = response.resources.results[typeSearch + "s"];
        if (itemsSuggestions.length > 0) {
          var result = "";
          for (var i = 0; i < itemsSuggestions.length; i++) {
            if (
              itemsSuggestions[i].id != 6623214993579 &&
              itemsSuggestions[i].id != 6623216205995
            ) {
              result += htmlItem(type, itemsSuggestions, i);
            }
          }

          if (type == "product") {
            result =
              result +
              `<div class='global-search sticky bottom-0 left-0 px-[20px] py-[10px] bg-primary cursor-pointer button--text-2 text-secondary-light uppercase text-center 2xl:col-end-3'>${window.general.more_results_translate}</div>`;
          }
          $("." + classInputResult).html(result);
        } else {
          var emptyProduct = emptyItem(type);
          $("." + classInputResult).html(emptyProduct);
        }
      },
    });
  };
  ("use strict");

  $(".faq-question--container").on("click", function () {
    var $question = $(this).children(".faq__question");
    $(".plus__icon").removeClass("opened");
    $question.children(".plus__icon").toggleClass("opened");
    if ($question.next().attr("aria-hidden") == "false") {
      $question.next().slideToggle(200).attr("aria-hidden", "true");
      $(".plus__icon").removeClass("opened");
    } else {
      $(".faq-question--container")
        .find('.faq__answer[aria-hidden="false"]')
        .not($question)
        .slideToggle(200)
        .attr("aria-hidden", "true");
      $question.next().slideToggle(200).attr("aria-hidden", "false");
    }
  });

  $(".faq-link").on("click", function () {
    var block = $(this).attr("link");
    $("html, body").animate(
      {
        scrollTop: $(block).offset().top - 150,
      },
      500
    );
  });
  ("use strict");

  var productDetails = {};
  if ($("[product-details]").html()) {
    productDetails = JSON.parse($("[product-details]").html());
  }

  document.addEventListener(
    "select-changed:product__option",
    function (event) {
      onOptionChanged();
    },
    false
  );

  function updateProductButton(variant, productId) {
    if (variant.available == 0) {
      $('.add__to__cart[product-id="' + productId + '"]')
        .html(window.general.outOfStockTranslate)
        .attr("id", "")
        .css("display", "none");

      $(".bannerProduct-button").text(
        window.general.outOfStockOneWordTranslate
      );
    } else {
      var selectText = $(".select-text-replace").text();

      const addToCartText = variant.preOrder
        ? window.general.preOrderTranslate
        : window.general.addToCartTranslate;

      if (
        selectText != "Sélectionnez votre taille" &&
        selectText != "Sélectionnez votre montant"
      ) {
        $('.add__to__cart[product-id="' + productId + '"]')
          .html(
            addToCartText +
              ' - <span id="product-price" style="margin-right: 3px;">' +
              variant.price +
              "</span>"
          )
          .attr("id", "")
          .css("display", "block")
          .attr("variant-available", true);
      } else {
        $('.add__to__cart[product-id="' + productId + '"]')
          .html(
            addToCartText +
              ' - <span id="product-price" style="margin-right: 3px;">' +
              variant.price +
              "</span>"
          )
          .attr("id", "");
      }
      $(".bannerProduct-button").text(window.general.addToCartOneWordTranslate);
    }
  }

  function onOptionChanged() {
    var productOptions = [];

    var variantId = null;

    for (var i = 1; i <= 3; i++) {
      productOptions[i - 1] =
        $(
          '.select__custom--selected-value[product-id="' +
            productDetails.productId +
            '"][name="product__option--' +
            i +
            '"]'
        )
          .text()
          .trim() || "";
    }
    if (productDetails && productDetails.variants.length > 1) {
      productDetails.variants.forEach(function (variant) {
        if (
          variant.option1 == productOptions[0] &&
          variant.option2 == productOptions[1] &&
          variant.option3 == productOptions[2]
        ) {
          $(
            '.add__to__cart[product-id="' + productDetails.productId + '"]'
          ).attr("variant-id", variant.id);

          var url =
            document.location.origin +
            document.location.pathname +
            ("?variant=" + variant.id);
          window.history.replaceState({ path: url }, "", url);

          if (!variantId) {
            variantId = variant.id;
            document.dispatchEvent(
              new CustomEvent("variant-changed", {
                detail: {
                  variant: variant,
                },
              })
            );
          }

          updateProductButton(variant, productDetails.productId);
        }
      });
    }
  }

  $(".quantity__change--selector-product").on("click", function () {
    console.log("plus");
    var type = $(this).attr("type");
    var currentQty = parseInt(
      $(".product__qty--container .quantity__current").val()
    );

    if (type == "minus") {
      if (currentQty != 0) {
        $(".product__qty--container .quantity__current").val(currentQty - 1);
      }
    } else {
      $(".product__qty--container .quantity__current").val(currentQty + 1);
    }
  });

  $(".bulle__custom--value").on("click", function () {
    var value = $(this).text();
    var option = $(this).attr("for");

    $('.select__custom--selected-value[for="' + option + '"]').text(value);
    $('.select__custom--selected-value-banner[name="' + option + '"]').text(
      value
    );
    $('.bulle__custom--value[for="' + option + '"]').removeClass(
      "border-secondary"
    );
    $(this).addClass("border-secondary");

    document.dispatchEvent(new CustomEvent("select-changed:product__option"));
  });

  $("body").on("click", ".bannerProduct-click", function () {
    var banner = $(this)
      .find(".select__custom--selected-value-banner")
      .attr("banner");
    console.log(banner);
    if ($(this).hasClass("opened")) {
      $(this).removeClass("opened");
      $(".bannerProduct-absolute[banner=" + banner + "]").css(
        "display",
        "none"
      );
      $(this).children(".icon--arrow-bottom").removeClass("opened");
    } else {
      $(this).addClass("opened");
      $(".bannerProduct-absolute[banner=" + banner + "]").css(
        "display",
        "grid"
      );
      $(this).children(".icon--arrow-bottom").addClass("opened");
    }
  });

  $(".banner-select").on("click", function () {
    var value = $(this).find(".bannerProduct-select").attr("value");
    $('.bulle__custom--value[value="' + value + '"]').click();

    var name = $(this).find(".bannerProduct-select").attr("for");
    $('.select__custom--selected-value-banner[name="' + name + '"]').text(
      value
    );

    if (name == "product__option--2") {
      $(".color-text-replace, .color-banner").text(value);
    }

    $(".bannerProduct-click").removeClass("opened");
    $(".bannerProduct-absolute").css("display", "none");
    $(".bannerProduct-click")
      .children(".icon--arrow-bottom")
      .removeClass("opened");

    $(".grid-click[for=" + name + "][value='" + value + "']").click();
  });

  $(".bannerProduct-button").on("click", function () {
    var id = $(this).attr("product-id");
    $(".add__to__cart[product-id=" + id + "]").click();
  });

  $(".accordeon-title").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".accordeon-hidden").removeClass("active");
      $(this).find(".plus__icon").removeClass("opened");
      $(this).next().slideToggle(200);
    } else {
      $(".accordeon-hidden.active").slideToggle(200);
      $(".accordeon-title, .accordeon-hidden").removeClass("active");
      $(".accordeon-title .plus__icon").removeClass("opened");
      $(this).addClass("active");
      $(this).siblings(".accordeon-hidden").addClass("active");
      $(this).find(".plus__icon").addClass("opened");
      $(this).next().slideToggle(200);
    }
  });

  $(".numero-bloon").on("click", function () {
    var numero = $(this).attr("num");
    if ($(".numero-bloon-container[num=" + numero + "]").hasClass("active")) {
    } else {
      $(".numero-bloon")
        .removeClass("bg-primary-light text-secondary-light")
        .addClass("bg-secondary-light text-primary-light");
      $(this)
        .addClass("bg-primary-light text-secondary-light")
        .removeClass("bg-secondary-light text-primary-light");
      $(".numero-bloon-container.active .infos-numero-bloon").slideToggle(200);
      $(".numero-bloon-container").removeClass("active");
      $(".numero-bloon-container[num=" + numero + "]").addClass("active");
      $(
        ".numero-bloon-container[num=" + numero + "] .infos-numero-bloon"
      ).slideToggle(200);
    }
  });

  $(".link-nav-product, .link-nav-collection").on("click", function () {
    var link = $(this).attr("link");
    $("html, body").animate(
      {
        scrollTop: $("." + link).offset().top - 200,
      },
      500
    );
  });

  $(document).ready(function () {
    // Écouteur d'événement pour le bouton de soumission
    $(".find-size-guide").on("click", function () {
      // Récupération des réponses aux questions
      var height, weight;
      var desk = $("#desk_guide").val();
      var gender = $("#sexe_guide").val();
      if (gender === "femme") {
        height = $("#height_guide_femme").val();
        weight = $("#weight_guide_femme").val();
      } else {
        height = $("#height_guide_homme").val();
        weight = $("#weight_guide_homme").val();
      }

      console.log(height, weight, desk);

      // Détermination de la taille du bloon en fonction des réponses
      var bloonSize = "";

      if (gender === "femme") {
        if (height === "1m10 à 1m45") {
          bloonSize = "Regular"; // kids
        } else if (
          height === "1m46 à 1m75" &&
          weight === "moins de 86kg" &&
          (desk === "bureau réglable en hauteur" ||
            desk === "bureau standard (72-77 cm)" ||
            desk === "je ne sais pas")
        ) {
          bloonSize = "Regular";
        } else {
          bloonSize = "XL";
        }
      } else {
        if (height === "1m10 à 1m45") {
          bloonSize = "Regular"; //kids
        } else if (
          height === "1m46 à 1m79" &&
          weight === "moins de 96kg" &&
          (desk === "bureau réglable en hauteur" ||
            desk === "bureau standard (72-77 cm)" ||
            desk === "je ne sais pas")
        ) {
          bloonSize = "Regular";
        } else if (
          height === "1m46 à 1m79" &&
          weight === "moins de 96kg" &&
          desk === "bureau haut (supérieur à 78cm)"
        ) {
          bloonSize = "XL";
        } else if (height === "1m46 à 1m79" && weight === "97kg et plus") {
          bloonSize = "XL";
        } else if (height === "plus de 1m80") {
          bloonSize = "XL";
        }
      }

      $(".step-one-guide").hide();
      $(".step-two-guide").show();
      // Affichage de la taille du bloon
      $(".resultat-guide").text(bloonSize);
      if (bloonSize == "KIDS" && productDetails.kid == "false") {
        $(".add-guide").hide();
        $(".text-info-guide").show().html(window.general.regular_to_kid);
      } else if (
        (bloonSize == "Regular" || bloonSize == "XL") &&
        productDetails.kid == "true"
      ) {
        $(".add-guide").hide();
        $(".text-info-guide").show().html(window.general.kid_to_regular);
      } else {
        $(".add-guide").show().attr("taille", bloonSize);
        $(".text-info-guide").hide();
      }
    });
  });

  $("#sexe_guide").change(function () {
    var selectedOption = $(this).val();
    console.log(selectedOption);
    if (selectedOption === "femme") {
      $(".femme").removeClass("hidden");
      $(".homme").addClass("hidden");
    } else {
      $(".femme").addClass("hidden");
      $(".homme").removeClass("hidden");
    }
  });

  $(".add-guide").on("click", function () {
    var taille = $(this).attr("taille");
    var id = $(this).attr("product-id");
    $("#guide-tailles .close").click();
    $(".select__custom--value[value=" + taille + "]").click();
    setTimeout(function () {
      $(".add__to__cart[product-id=" + id + "]").click();
    }, 200);
  });

  $(".restart-guide").on("click", function () {
    $(".step-one-guide").show();
    $(".step-two-guide").hide();
  });
});
